import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrashAlt, faEdit, faX, faGear } from '@fortawesome/free-solid-svg-icons'
import Loading from './Loading';
import SubirInventario from './SubirInventario';
import VerInventario from './VerInventario';
import EditarInventario from './EditarInventario';
import InventarioConfiguracion from './InventarioConfiguracion';

const Inventario = ({ baseUrl, Titulo, urlProductos }) => {
	const [productoSelecionadoActualizar, setProductoSelecionadoActualizar] = useState()

	const [funcion, setFuncion] = useState('ver')

	const productoSelecccionado = e => {
		setProductoSelecionadoActualizar(e)
		setFuncion('editar')
	}

	const cambiarInventario = (data) => setFuncion(data)


	return (
		<div>
			<div className="row">
				<div className="col-md-6">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						{
							{
								'ver': <>
									<button
										onClick={e => setFuncion('crear')}
										className="btn boton_estandar btn-lg derecha">
										<FontAwesomeIcon icon={faPlus} />
									</button>
									<button
										onClick={e => setFuncion('configuracion')}
										className="btn boton_estandar btn-lg derecha">
										<FontAwesomeIcon icon={faGear} />
									</button>
								</>,
								'crear': <button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar btn-lg derecha">
									<FontAwesomeIcon icon={faX} />
								</button>,
								'configuracion': <button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar btn-lg derecha">
									<FontAwesomeIcon icon={faX} />
								</button>
							}[funcion]
						}
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					{
						{
							'editar': <EditarInventario productoSelecionadoActualizar={productoSelecionadoActualizar} setFuncion={setFuncion} baseUrl={baseUrl} />,
							'eliminar': null,
							'configuracion': <InventarioConfiguracion cambiarInventario={cambiarInventario} />,
							'cargando': <Loading />,
							'ver': <VerInventario baseUrl={baseUrl} productoSelecccionado={productoSelecccionado} />,
							'crear': <SubirInventario urlProductos={urlProductos} setFuncion={setFuncion} baseUrl={baseUrl} />
						}[funcion]
					}
				</div>
			</div>
		</div>
	)
}

export default Inventario